import { useEffect, useState } from "react";
import { useLocation, type WindowLocation } from "@gatsbyjs/reach-router";
import { checkIfLocalStorageIsSupportedByBrowser } from "./local-storage-item";

const featureEnabled = (name: string) => `${name}=true`;
const featureDisabled = (name: string) => `${name}=false`;

const activeFeatureFlags = ["destination-trending-items"] as const;
type ActiveFeatureFlags = (typeof activeFeatureFlags)[number];

// eslint-disable-next-line import/no-unused-modules
export const useClientSideFeatureFlag = (name: ActiveFeatureFlags) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const isLocalStorageEnabled = checkIfLocalStorageIsSupportedByBrowser();
  const location = useLocation();
  const search = location.search;

  useEffect(() => {
    if (search.includes(featureEnabled(name))) {
      if (isLocalStorageEnabled) window.localStorage.setItem(name, "true");
      setIsEnabled(true);
      return;
    }
    if (search.includes(featureDisabled(name))) {
      if (isLocalStorageEnabled) window.localStorage.removeItem(name);
      setIsEnabled(false);
      return;
    }
    if (isLocalStorageEnabled && window.localStorage.getItem(name) === "true") {
      setIsEnabled(true);
      return;
    }
  }, [isLocalStorageEnabled, name, search]);

  return isEnabled;
};

// eslint-disable-next-line import/no-unused-modules
export const isDev = (location: WindowLocation | undefined) =>
  isDevBuild() && location?.hostname == "localhost";

export const isDevBuild = () => process.env.NODE_ENV == "development";

export const isEnvFeatureEnabled = (
  envVariable: string | undefined
): boolean => {
  return (envVariable || "false").toLowerCase() === "true";
};
